<template>
  <div class="root">
    <div class="top">
      <div class="centerContainer">
        <div class="logo">
          <span style="font-size: 6rem;">3</span>
          <div class="kContainer">
            <icon class="coeur" icon="heart"/>
            <icon style="margin-left: 10px" class="coeur" icon="heart"/>
            <icon style="margin-left: 20px" class="coeur" icon="heart-broken"/>
          </div>
          <span style="font-size: 3rem;">System</span>
        </div>
      </div>
      <img src="/FondHome2.jpg">
      <div class="flou"></div>
    </div>
    <div class="bot">
      <icon @click="scrollToMid()" class="icon" icon="chevron-down"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'accueil',
  methods:{
    scrollToMid(){
            window.scrollTo(window.innerWidth , window.innerHeight);
        }
  }
}
</script>

<style lang="stylus" scoped>

.root {
  height: 100vh;
  width: 100%;
  .top {
    position: relative;
    height: 93%;
    width: 100%;
    .flou {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
//        background-color: rgba(192, 192, 192, .6)
        z-index: 10;
    }
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .centerContainer {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 999;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #24292e;
      width: 320px;
      height: 320px;
      border-radius: 79% 21% 90% 10% / 30% 51% 49% 70% ;
    }
  }

.logo {
  display: flex;
  .kContainer {
    left: 9%;
    display: flex;
    flex-direction: column;
  }
  span {
    color: white;
  }
}

 .coeur {
  color: red;
  width: 50px;
  height: 50px;
}

  .bot {
    background-color: #585B56;
    height: 7%;
    width: 100%;
    display: flex;
    justify-content: center
    align-items: center;
    .icon {
      color: #24292e;
      width: 200px;
      height: 50px;
    }
  }
}
</style>